<template>
  <a-config-provider :theme="themeConfig">
    <div class="app-container">
      <router-view v-slot="{ Component, route }">
        <div :key="route.path" class="page-wrapper">
          <component :is="Component" />
        </div>
      </router-view>
      <security-notice />
      <!-- Vue Sonner Toaster - 全局通知容器 -->
      <Toaster
        rich-colors
        position="top-center"
        :duration="3500"
        :offset="60"
        :close-button="true"
        :theme="'light'"
      />
    </div>
  </a-config-provider>
</template>

<script setup lang="ts">
import { theme } from "ant-design-vue";
import { computed, onBeforeUnmount } from "vue";
import { jwtLifecycleService } from "@/services/jwtLifecycleService";
import SecurityNotice from "@/components/SecurityNotice.vue";
import { Toaster } from "vue-sonner";

const themeConfig = computed(() => ({
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#2F54EB",
    borderRadius: 4,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
}));

// 在组件卸载前清理定时器
onBeforeUnmount(() => {
  // 停止JWT生命周期管理
  jwtLifecycleService.stop();
});
</script>

<style>
.app-container {
  position: relative;
  min-height: 100vh;
}

/* CSS-only 过渡动画 - 替代 Vue Transition */
.page-wrapper {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 确保动画流畅 */
.page-wrapper > * {
  animation: inherit;
}
</style>
